import { api } from "./api";

export const gedOrdersRequest = (payload) => api.post(`/get-all-orders`, payload);

export const getOrdersByUserRequest = (payload) => api.post(`/get-orders-byUser`, payload);

export const getOrdersByUserFreePrintRequest = (payload) => api.post(`/get-orders-byUser-free-print`, payload);

